'use strict';

var Functions$BsBastet = require("bs-bastet/bastet/src/Functions.bs.js");

function MonoidExtensions(M) {
  var BsMonoidExtensions = Functions$BsBastet.Monoid(M);
  return {
          BsMonoidExtensions: BsMonoidExtensions,
          guard: BsMonoidExtensions.guard,
          power: BsMonoidExtensions.power
        };
}

exports.MonoidExtensions = MonoidExtensions;
/* Functions-BsBastet Not a pure module */
